function hasSmsOptOutStamp(value) {
  if (value == null) return false;
  const text = String(value).trim();
  return Boolean(text) && !text.startsWith('0000-00-00');
}

function peopleSmsOptInMark(person) {
  if (Number(person && person.smsOptIn) === 1) return 'in';
  if (hasSmsOptOutStamp(person && person.smsOptOutAt)) return 'out';
  return 'unset';
}

function personSmsFlagOn(person) {
  return peopleSmsOptInMark(person) === 'in';
}

function personChatNotifyFlagOn(person) {
  return Number(person && person.pixieNotifications) === 1;
}

function placePeopleNotifColumn(headers) {
  const columns = (Array.isArray(headers) ? headers : []).filter(
    (header) =>
      header &&
      header.field !== 'pixieNotifications' &&
      header.label !== 'notif.',
  );
  const column = {
    label: 'notif.',
    field: 'pixieNotifications',
    width: '52px',
    align: 'center',
    display: 'check',
    title: 'PWA notifications enabled',
  };
  const optIn = columns.findIndex(
    (header) => header.field === 'smsOptIn' || header.label === 'opt-in',
  );
  if (optIn === -1) return [...columns, column];
  return [...columns.slice(0, optIn + 1), column, ...columns.slice(optIn + 1)];
}

function personMatchesPeopleSearch(person, tokens) {
  const normalized = (Array.isArray(tokens) ? tokens : [])
    .map((token) => String(token || '').trim().toLowerCase())
    .filter(Boolean);
  if (!normalized.length) return true;
  const values = Object.values(person || {}).map((value) =>
    value ? String(value).toLowerCase() : '',
  );
  return normalized.every((token) => {
    if (token === 'opt-in' || token === 'optin') {
      return peopleSmsOptInMark(person) === 'in';
    }
    if (token === 'opt-out' || token === 'optout') {
      return peopleSmsOptInMark(person) === 'out';
    }
    return values.some((value) => value.includes(token));
  });
}

module.exports = {
  personMatchesPeopleSearch,
  peopleSmsOptInMark,
  personSmsFlagOn,
  personChatNotifyFlagOn,
  placePeopleNotifColumn,
};
